import { LoadCitiesFromDistrict } from 'domain/usecases/address/load-cities-from-district'
import { AddressRepository } from 'repository/interfaces/address-repository'

export class RemoteLoadCitiesFromDistrict implements LoadCitiesFromDistrict {
  private readonly addressRepository: AddressRepository

  constructor(addressRepository: AddressRepository) {
    this.addressRepository = addressRepository
  }

  load(
    params: LoadCitiesFromDistrict.Params
  ): Promise<LoadCitiesFromDistrict.Model> {
    return this.addressRepository.loadCitiesFromDistrict(params)
  }
}
